export default __webpack_public_path__ + "static/media/Exteriors 029.e1449133.jpg";